export const TOAST_CONTAINER = {
    zIndex: 1999
};

export const CLOSE_TIME = 5000;
